module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAMFBMVEUAAAD9XmL9X2H/YGD8XmH/YGP/YGD9XmH9XmL8XWL8XmH/YGD9XmH9XWL/YGD9X2JNBaItAAAAD3RSTlMA0PBAwFAgoIBgsDCQcBA2tgLAAAAAvElEQVQoz2PABRgF0AT4P2AI4NHCHgBjsRaAqfc/YQLz/4Epzv8JDObyH4sZ2P5PgEhMZ0j5DwRuDJUwpdz6IIFPG+DGJv0HAzW4gD9E4AuMz/wfCgzAdncEsIM4QkB8AMhh4P//gfH/f63/9ov+/3cAckAq+P9/Mvx4X1j//weQCiAACfyVBwlADQVp+fwfpAUqADJU8T/IUAxr0R2G6XScnoN5HwmY+385zIAXyP///xFTgICejwQEEAAAv3eHl3kfgoUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/my/images/answer.png
// module id = lN/u
// module chunks = 0